<template>
    <!-- Page header -->
    <div>
        <div class="page-header page-header-light">
            <div class="page-header-content header-elements-md-inline">
                <div class="page-title d-flex">
                    <h4><span class="font-weight-semibold">Workers</span> </h4>
                    <a href="#" class="header-elements-toggle text-default d-md-none"><i class="icon-more"></i></a>
                </div>
            </div>
        </div>
        <!-- /page header -->
        <!-- Content area -->
        <div class="content">
            <div class="card">
                <div class="table-responsive" :class="{'loading-mask': loading}">
                    <button @click="load" class="btn btn-primary pull-right" style="margin: 10px">Refresh list</button>
                    <table class="table table-striped table-xs" style="min-height: 100px">
                        <thead>
                            <tr>
                                <th>No.</th>
                                <!-- <th v-tooltip="'IP address'"><i class="icon icon-info22" />IP</th> -->
                                <th v-tooltip="'Name of the worker'"><i class="icon icon-info22" />Name</th>
                                <th v-tooltip="'IP addresses'"><i class="icon icon-info22" />IP addresses count</th>
                                <th v-tooltip="'IP addresses'"><i class="icon icon-info22" />IP addresses</th>
                                <th v-tooltip="'Machine hostname'"><i class="icon icon-info22" />Hostname</th>
                                <th v-tooltip="'OS Load avg'"><i class="icon icon-info22" />Load 1/5/15</th>
                                <th v-tooltip="'offline - no process <br/> idle - process works but does no sending <br/> processing - worker does sending'"><i class="icon icon-info22" />Status</th>
                                <th v-tooltip="'How much messages worker sents per second'"><i class="icon icon-info22" />Messages per second</th>
                                <th v-tooltip="'When worker was last online'"><i class="icon icon-info22" />Last check at</th>
                                <th v-tooltip="'When worker was created'">Created at</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="r,k in rows">
                            <tr>
                                <td style="width:10px">{{k+1}}</td>
                                <!-- <td>{{r.ip}}</td> -->
                                <td><strong>{{r.name}}</strong></td>
                                <td>{{r.ips.length}}</td>
                                <td>{{r.ips}}</td>
                                <td>{{r.hostname}}</td>
                                <td>{{r.load_avg}}</td>
                                <td>
                                    <worker-status :worker="r" />
                                </td>
                                <td>{{r.current_per_sec|toFixed}}</td>
                                <td>{{r.last_active_at|formatDate}}</td>
                                <td>{{r.created_at|formatDate}}</td>
                                <!-- <td>
                                    <div class="btn-group">
                                        <button class="btn btn-primary" v-tooltip="'Worker settings'" @click="worker = r"><i class="icon icon-pencil" /></button>
                                        <button v-tooltip="'Resets worker starts'" class="btn btn-danger" @click="reset($event, r)"><i class="icon icon-reset" /></button>
                                        <button class="btn btn-danger" @click="remove($event, r)"><i class="icon icon-trash" /></button>
                                    </div>
                                </td> -->
                            </tr>
                            <tr v-if="r.test_messages_result"><td colspan="11">
                                Latest test messages sent:<br/>
                                <template v-for="m in r.test_messages_result">
                                Date: {{m.date|formatDate}}, Success: <strong>{{m.success}}</strong>, email: {{m.email}}, error: {{m.error ||"-"}}</br>
                                </template>
                                </td></tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import EventBus from "@/event_bus";
let interval;
export default {
  components: {},
  data() {
    return {
      rows: [],
      loading: true,
      adding: false,
      worker: null,
    };
  },
  methods: {
    remove(_, r) {
      this.$confirm().then(() => {
        this.$api.deleteReq("worker/" + r._id).then((res) => {
          this.load();
        });
      });
    },
    reset(_, r) {
      this.$confirm().then(() => {
        this.$api.postReq("worker/" + r._id + "/reset").then((res) => {
          this.load();
        });
      });
    },
    load(showloader) {
      this.$api.getReq("worker").then((res) => {
        this.rows = res.body.data;
        this.loading = false;
      });
    },
  },
  destroyed() {
    clearInterval(interval);
  },
  mounted() {
    this.load();

    interval = setInterval(() => {
      this.load();
    }, 5 * 1000);
  },
};
</script>
<style>
.avsquare {
  width: 7px;
  height: 100%;
  float: left;
  cursor: pointer;
  border-left: 1px solid rgba(0, 0, 0, 0.1);
}

.avsquare:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.avsquare:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

tbody .btn {
  padding: 3px 11px;
}
</style>


// WEBPACK FOOTER //
// src/components/WorkerList.vue